export default "__VITE_ASSET__DfUDY9nn__"